export const getSafeRedirectPath = (
  redirectPath: string | null
): string | null => {
  if (redirectPath == null) return null;

  const normalizedRedirectPath = redirectPath.trim();
  if (normalizedRedirectPath.length === 0) return null;

  // 相対パスは引き続き許可（オープンリダイレクト防止のため "//" は拒否）。
  if (normalizedRedirectPath.startsWith('/')) {
    if (normalizedRedirectPath.startsWith('//')) return null;
    return normalizedRedirectPath;
  }

  // 絶対 URL は、https/http のみ許可する。
  let redirectUrl: URL;
  try {
    redirectUrl = new URL(normalizedRedirectPath);
  } catch {
    return null;
  }

  if (!['http:', 'https:'].includes(redirectUrl.protocol)) return null;
  if (redirectUrl.username || redirectUrl.password) return null;

  return redirectUrl.toString();
};

export const getSafeExternalUrl = (
  rawUrl: string | null | undefined
): string | null => {
  if (rawUrl == null) return null;

  const urlText = rawUrl.trim();
  if (urlText.length === 0) return null;

  try {
    const parsedUrl = new URL(urlText);
    if (!['http:', 'https:'].includes(parsedUrl.protocol)) return null;
    return parsedUrl.toString();
  } catch {
    return null;
  }
};

export const createUrlWithRedirectQuery = (
  basePath: string,
  redirectPath: string | null,
  origin = window.location.origin
): string => {
  const baseUrl = new URL(basePath, origin);
  const safeRedirectPath = getSafeRedirectPath(redirectPath);

  if (safeRedirectPath) {
    baseUrl.searchParams.set('to', safeRedirectPath);
  }

  return baseUrl.toString();
};
